// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.label__yj1wfY3P34{text-align:center}table.compareContactsTable__Q8bxGcjU8k{min-width:0}`, "",{"version":3,"sources":["webpack://./src/app/components/appModals/components/mergeContactsModal/components/previewContact/previewContact.module.scss"],"names":[],"mappings":"AAAA,mBACE,iBAAA,CAGF,uCACE,WAAA","sourcesContent":[".label {\n  text-align: center;\n}\n\ntable.compareContactsTable {\n  min-width: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"label": `label__yj1wfY3P34`,
	"compareContactsTable": `compareContactsTable__Q8bxGcjU8k`
};
export default ___CSS_LOADER_EXPORT___;
